import { LabelInput } from '@/features/eventMetadata/components/LabelInput';
import { LabelType, type ExperienceFeed } from '@/types/gql.generated';

type Props = {
  feed: ExperienceFeed;
  labelType: LabelType;
  // Receives the selected label ids, in selection order. Each row wires this to
  // its own update hook (feeds vs sources), mirroring FeedCategory.
  onChange: (labelIds: string[]) => void;
  isReadOnly?: boolean;
};

export const FeedLabels = ({
  feed,
  labelType,
  onChange,
  isReadOnly,
}: Props) => (
  <LabelInput
    isReadOnly={isReadOnly}
    labelType={labelType}
    value={labelType === LabelType.Default ? feed.labels : feed.whoLabels}
    onChange={(labels) => onChange(labels.map((label) => label.id))}
  />
);
